import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL;

export const buildExportedRightsDownloadUrl = async (documentTypeId, filePath, fileName, accessToken) =>
  `${url}/DocumentTypes/${documentTypeId}/download-exported-rights-list/file/${encodeURIComponent(filePath)}/${encodeURIComponent(
    fileName
  )}?access_token=${accessToken}`;
